import IconMenuApp from '@/assets/images/menu-app.png';
import IconSearch from '@/assets/images/search.svg';
import IconMessage from '@/assets/images/message-menu.svg';
import IconAdvertisement from '@/assets/images/advertisement-line.svg';
import IconMenuList from '@/assets/images/menu-list.svg';
import IconOptionSharp from '@/assets/images/options-sharp.svg';
import IconNotifications from '@/assets/images/notifications-outline.svg';
import IconNoticePush from '@/assets/images/notice-push.svg';
import IconLogout from '@/assets/images/logout.svg';
import IconInfoCircle from '@/assets/images/info-circle-fill-inactive.png';
import IconInfoCircleActive from '@/assets/images/info-circle-fill-active.png';
import IconAccountInfo from '@/assets/images/account-circle-inactive.svg';
import IconAccountInfoActive from '@/assets/images/account-circle-active.svg';
import IconLockFill from '@/assets/images/lock-fill-inactive.svg';
import IconLockFillActive from '@/assets/images/lock-fill-active.svg';
import IconMdListBox from '@/assets/images/md-list-box-inactive.svg';
import IconMdListBoxActive from '@/assets/images/md-list-box-active.svg';
import IconAppointment from '@/assets/images/appointment-inactive.svg';
import IconAppointmentActive from '@/assets/images/appointment-active.svg';
import IconEvaluation from '@/assets/images/evaluation-inactive.svg';
import IconEvaluationActive from '@/assets/images/evaluation-active.svg';
import IconMonthlyPlan from '@/assets/images/monthly-plan-inactive.svg';
import IconMonthlyPlanActive from '@/assets/images/monthly-plan-active.svg';

export const TYPE_SUCCESS = 'success';
export const TYPE_ERROR = 'error';

export const ACCESS_TOKEN = 'realestate_access_token';
export const REFRESH_TOKEN = 'realestate_refresh_token';
export const REMEMBER_ME = 'remember_me';
export const USER_ACCOUNT_ID = 'user_account_id';
export const FCM_TOKEN = 'fcm_token';
export const MY_PREFECTURE = 'realestate_my_prefecture';
export const MY_CORPORATION = 'realestate_my_corporation';
export const DEFAULT_PREFECTURE = '13';
export const COOKIE_EXPIRE = 30;
export const MY_BID_ESTATE = 'realestate_bid_estate';
export const MY_BREADCRUMB = 'realestate_breadcrumb';

export const DEFAULT_DATE_FORMAT = 'YYYY/MM/DD';
export const DATE_FORMAT_DASH = 'YYYY-MM-DD';
export const DEFAULT_TIME_FORMAT = 'HH:mm';
export const DEFAULT_MONTH_FORMAT = 'YYYY/MM';
export const DEFAULT_MONTH_FORMAT_JP = 'YYYY年MM月';
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm';
export const DB_DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss';
export const DATE_TIME_FORMAT = 'YYYY年MM月DD日';
export const DATE_YEAR_MONTH = 'YYYY-MM';
export const YEAR_MONTH_FORMAT = 'YYYY年MM月分';
export const FORMAT_DATE = 'YYYYMMDD_HHmmss';
export const FORMAT_DATE_NOTIFICATION = 'YYYY.MM.DD HH:mm';
export const NUMBER_EN_US_FORMAT = 'en-US';
export const DEFAULT_LIMIT = 15;
export const MAN_TO_YEN = 10000;
export const MAX_WIDTH_MESSAGE = 1080;

export const STATION_TYPE = 'train';
export const TYPE_IMAGE = [
  'image/jpeg',
  'image/png',
  'image/jpg',
  'image/gif',
  'image/bmp',
  'image/x-ms-bmp',
];
export const MAX_SIZE_IMAGE = 20 * 1024 * 1024;
export const TYPE_FILE = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/jpg',
  'image/gif',
  'image/bmp',
];

export const NUMBER_SLIDER = 3;

export const MAIN_MENU = [
  {
    routerName: 'AccountInfo',
    title: 'マイメニュー',
    exact: true,
    icon: IconMenuApp,
    permissions: [1],
    meta: 'Account Info',
    subMenu: [
      {
        title: '基本情報',
        iconActive: IconInfoCircleActive,
        iconInActive: IconInfoCircle,
        routerName: 'Basic Info',
        exact: false,
      },
      {
        title: 'パスワード変更',
        iconActive: IconLockFillActive,
        iconInActive: IconLockFill,
        routerName: 'Change Password',
        exact: false,
      },
      {
        title: '請求先情報',
        iconActive: IconAccountInfoActive,
        iconInActive: IconAccountInfo,
        routerName: 'Bank Account Info',
        exact: false,
      },
      {
        title: '担当者アカウント管理',
        iconActive: IconMdListBoxActive,
        iconInActive: IconMdListBox,
        routerName: 'User Account',
        exact: false,
      },
      {
        title: '利用明細',
        iconActive: IconAppointmentActive,
        iconInActive: IconAppointment,
        routerName: 'Usage Detail',
        exact: false,
      },
      {
        title: '評価詳細確認',
        iconActive: IconEvaluationActive,
        iconInActive: IconEvaluation,
        routerName: 'Rating Detail',
        exact: false,
      },
      {
        title: '月額プラン情報確認',
        iconActive: IconMonthlyPlanActive,
        iconInActive: IconMonthlyPlan,
        routerName: 'Monthly Plan',
        exact: false,
      },
    ],
  },
  {
    routerName: 'Search Favorite',
    title: 'お気に入り検索',
    exact: false,
    icon: IconSearch,
    permissions: [1, 2],
    meta: null,
  },
  {
    routerName: 'Message',
    title: 'メッセージ',
    exact: false,
    icon: IconMessage,
    permissions: [1],
    meta: 'Message',
  },
  {
    routerName: 'Option',
    title: 'オプション',
    exact: false,
    icon: IconOptionSharp,
    permissions: [1],
    meta: 'Option',
  },
  {
    routerName: 'Advertising Option',
    title: '広告オプション',
    exact: false,
    icon: IconAdvertisement,
    permissions: [1],
    meta: 'Advertising Option',
  },
  {
    routerName: 'List Bidding',
    title: '各種リスト',
    exact: false,
    icon: IconMenuList,
    permissions: [1],
    meta: 'List Bidding',
  },
];
export const SUB_MENU = [
  {
    icon: IconNotifications,
    title: 'オークション通知',
    logOut: false,
    permissions: [1],
  },
  {
    icon: IconNoticePush,
    title: 'お知らせ',
    routerName: 'News',
    logOut: false,
  },
  {
    icon: IconLogout,
    title: 'ログアウト',
    name: 'home',
    logOut: true,
  },
];

export const START_MENU = [
  {
    path: '/login',
    title: 'ログイン',
  },
  {
    path: '/register/term',
    title: '会員登録',
  },
  {
    path: '/news',
    title: 'お知らせ',
  },
];

export const TAB_ALL = 'all';
export const TAB_UNREAD = 'unread';
export const NOTI_TABS = {
  TAB_ALL,
  TAB_UNREAD,
};
export const INVALID_DATE = 'Invalid Date';
export const PAGE_DEFAULT = 1;
export const MAX_LENGTH_TEXT_AREA = 30000;
export const TYPE_IMAGE_INPUT_ACCEPT = 'image/jpeg,image/png,image/jpg,image/gif,image/bmp,image/x-ms-bmp';
export const SELLER_ID_NOT_SHOW = 0;
export const RECEIVE_EMAIL_INFO_DEFAULT = 1;
